module.exports = __webpack_public_path__ + "img/mobile_index_background.1f454e84.svg";